module.exports = __webpack_public_path__ + "img/p9.56a5732c.png";